// extracted by mini-css-extract-plugin
export default {"globalLoader":"AuthGlobalLoader_globalLoader__mPlWj","smooothpulse":"AuthGlobalLoader_smooothpulse__qXgxk"};